import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CmsConfig, I18nModule, provideConfig } from '@spartacus/core';
import { OutletModule, PageComponentModule } from '@spartacus/storefront';
import { CustomTabParagraphContainerComponent } from './tab-paragraph-container.component';

@NgModule({
  imports: [CommonModule, PageComponentModule, OutletModule, I18nModule],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        CMSTabParagraphContainer: {
          component: CustomTabParagraphContainerComponent,
        },
      },
    }),
  ],
  declarations: [CustomTabParagraphContainerComponent],
  exports: [CustomTabParagraphContainerComponent],
})
export class CustomTabParagraphContainerModule {}
